import { lazy } from "react";

const DMS_Dashboard = lazy(() => import("@/pages/DMS/Dashboard/index"));
const DMS_Documents = lazy(() => import("@/pages/DMS/Documents/index"));
const DMS_MyDocuments = lazy(() => import("@/pages/DMS/MyDocuments/index"));
const DMS_Incoming = lazy(() => import("@/pages/DMS/Incoming/index"));
const DMS_Outgoing = lazy(() => import("@/pages/DMS/Outgoing/index"));
const DMS_Archive = lazy(() => import("@/pages/DMS/Archive/index"));

const DMS_Settings = lazy(() => import("@/pages/DMS/StaticData/index"));
const DMS_Settings_DocumentTypes = lazy(() => import("@/pages/DMS/StaticData/DocumentTypes/index"));
const DMS_Settings_PrivacyTypes = lazy(() => import("@/pages/DMS/StaticData/DocumentPrivacyTypes/index")); 
const DMS_Settings_DocumentCategories = lazy(() => import("@/pages/DMS/StaticData/DocumentCategories/index"));
const DMS_Settings_PriorityTypes = lazy(() => import("@/pages/DMS/StaticData/PriorityTypes/index"));
const DMS_Settings_DocumentStatus = lazy(() => import("@/pages/DMS/StaticData/DocumentStatus/index"));

// Workflow & Process
const DMS_Settings_WorkFlow = lazy(() => import("@/pages/DMS/StaticData/WorkFlows/index"));
/* const DMS_Settings_ProcessingLimits = lazy(() => import("@/pages/DMS/StaticData/ProcessingLimits/index")); */

// Organization Structure
/* const DMS_Settings_Offices = lazy(() => import("@/pages/DMS/StaticData/Offices/index")); */

// Retention & Archives
/* const DMS_Settings_RetentionSchedules = lazy(() => import("@/pages/DMS/StaticData/RetentionSchedules/index")); */
const DMS_Settings_ArchiveLocations = lazy(() => import("@/pages/DMS/StaticData/ArchiveLocations/index"));
const DMS_Settings_DisposalMethods = lazy(() => import("@/pages/DMS/StaticData/DisposalMethods/index"));

const DMS_Reports = lazy(() => import("@/pages/DMS/Reports/index"));

export var dmsRoutes = [
    { path: "/dms/dashboard", component: <DMS_Dashboard /> },
    { path: "/dms/documents", component: <DMS_Documents /> },
    { path: "/dms/mydocuments", component: <DMS_MyDocuments /> },
    { path: "/dms/incoming", component: <DMS_Incoming /> },
    { path: "/dms/outgoing", component: <DMS_Outgoing /> },
    { path: "/dms/archive", component: <DMS_Archive /> },

    { path: "/dms/settings", component: <DMS_Settings /> },

    // Document Classification
    { path: "/dms/settings/documenttypes", component: <DMS_Settings_DocumentTypes /> },
     { path: "/dms/settings/privacytypes", component: <DMS_Settings_PrivacyTypes /> }, 
    { path: "/dms/settings/documentcategories", component: <DMS_Settings_DocumentCategories /> },
    { path: "/dms/settings/prioritytypes", component: <DMS_Settings_PriorityTypes /> },
    { path: "/dms/settings/documentstatus", component: <DMS_Settings_DocumentStatus /> },

    // Workflow & Process
    { path: "/dms/settings/workflows", component: <DMS_Settings_WorkFlow /> },
/*     { path: "/dms/settings/processinglimits", component: <DMS_Settings_ProcessingLimits /> }, */

    // Organization Structure
/*     { path: "/dms/settings/offices", component: <DMS_Settings_Offices /> }, */

    // Retention & Archives
/*     { path: "/dms/settings/retentionschedules", component: <DMS_Settings_RetentionSchedules /> }, */
    { path: "/dms/settings/archivelocations", component: <DMS_Settings_ArchiveLocations /> },
    { path: "/dms/settings/disposalmethods", component: <DMS_Settings_DisposalMethods /> },

    { path: "/dms/reports", component: <DMS_Reports /> },
];